if (!customElements.get('site-search')) {
  class SiteSearch extends HTMLElement {
    connectedCallback() {
      this.toggleButton = this.querySelector('.site-search__toggle');
      this.panel = this.querySelector('.site-search__panel');
      if (!this.toggleButton || !this.panel) return;

      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);

      this.toggleButton.addEventListener('click', (event) => {
        event.preventDefault();
        if (this.panel.hidden) {
          this.open();
        } else {
          this.close();
        }
      });
    }

    open() {
      this.panel.hidden = false;
      this.toggleButton.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);

      const input = this.panel.querySelector('input[type="search"]');
      if (input) {
        requestAnimationFrame(() => input.focus());
      }
    }

    close() {
      this.panel.hidden = true;
      this.toggleButton.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
    }

    onDocumentClick(event) {
      if (!this.contains(event.target)) this.close();
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
        this.toggleButton.focus();
      }
    }
  }

  customElements.define('site-search', SiteSearch);
}
